import sample from "lodash/sample";
import random from "lodash/random";
import { ARBITRUM, AVALANCHE, AVALANCHE_FUJI, CUSTOM_DEV_NETWORK } from "./chains";
import { isDevelopment } from "./env";

const ORACLE_KEEPER_URLS = {
  [ARBITRUM]: isDevelopment() ? ["https://arbitrum-api.gmxinfra.io", "https://arbitrum-api.gmxinfra2.io"] : [],

  [AVALANCHE]: isDevelopment() ? ["https://avalanche-api.gmxinfra.io", "https://avalanche-api.gmxinfra2.io"] : [],

  [AVALANCHE_FUJI]: isDevelopment() ? ["https://synthetics-api-avax-fuji-upovm.ondigitalocean.app"] : [],
  [CUSTOM_DEV_NETWORK]: [],
};

export function getOracleKeeperUrl(chainId: number, index: number) {
  const urls = ORACLE_KEEPER_URLS[chainId];

  if (!urls || !urls.length) {
    // console.warn(`[oracleKeeper] no URLs found for chainId: ${chainId}`);
    return undefined;
  }

  return urls[index] || urls[0];
}

export function getOracleKeeperNextIndex(chainId: number, currentIndex: number) {
  const urls = ORACLE_KEEPER_URLS[chainId];

  if (!urls || urls.length === 0) {
    console.warn(`[oracleKeeper] no URLs found for chainId: ${chainId}`);
    return 0;
  }

  return urls[currentIndex + 1] ? currentIndex + 1 : 0;
}

export function getOracleKeeperRandomIndex(chainId: number, bannedIndexes?: number[]): number {
  const urls = ORACLE_KEEPER_URLS[chainId];
  if (bannedIndexes?.length) {
    const filteredUrls = urls.filter((url, i) => !bannedIndexes.includes(i));

    if (filteredUrls.length) {
      const url = sample(filteredUrls);
      return urls.indexOf(url);
    }
  }

  return random(0, urls.length - 1);
}
